import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ThemeProvider } from './hooks/useTheme.jsx'
import { A11yProvider } from './components/A11yProvider.jsx'
import { registerServiceWorker } from './utils/serviceWorkerRegistration'
import { unregisterServiceWorker } from './utils/cacheManager'
import ErrorBoundary from './components/debug/ErrorBoundary'
import * as Sentry from "@sentry/react";
import { initSentry } from './lib/sentry'

initSentry()

// React 19 entrega sus errores a estos handlers en vez de a window.onerror; así llegan a Sentry. Reemplazan los
// de React, que solo los escribían en la consola: ErrorBoundary ya escribe los que atrapa, el resto se escribe aquí.
const reportReactError = Sentry.reactErrorHandler()
const logAndReport = (error, errorInfo) => {
  console.error(error)
  reportReactError(error, errorInfo)
}

createRoot(document.getElementById('root'), {
  onUncaughtError: logAndReport,
  onCaughtError: reportReactError,
  onRecoverableError: logAndReport,
}).render(
  <ErrorBoundary fallback={
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Algo salió mal</h1>
      <p>Por favor, revisa la consola del navegador para más detalles.</p>
      <button onClick={() => window.location.reload()}>Recargar página</button>
    </div>
  }>
    <ThemeProvider>
      <A11yProvider>
        <App/>
      </A11yProvider>
    </ThemeProvider>
  </ErrorBoundary>
)

// En `vite dev` el service worker serviría módulos viejos desde su caché (estrategia cache-first),
// ocultando los cambios. Se desregistra y limpia cualquiera que haya quedado instalado.
if (import.meta.env.DEV) unregisterServiceWorker()
else registerServiceWorker()
